module.exports = __webpack_public_path__ + "static/media/initial_page_triangles.45836424.svg";